(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewProfile.controller:OtherHubImportDialogCtrl
	 * 
	 * @description
	 * 
	 */
	angular.module('crewProfile').controller('otherHubImportCtrl',
			otherHubImportCtrl);

	function otherHubImportCtrl($uibModalInstance, modalParams, ProfileService,
			MessageService, EventManagerService, PopupManager) {

		var vm = this;
		vm.ctrlName = 'otherHubImportCtrl';

		vm.importHour = angular.copy(modalParams.importHour);
		vm.model = {
			importHoursData : adaptOtherHubHourData(),
			masterList : {
				clients : modalParams.masterList.autoImportClients
			},
			fromDateAfterToDate : false,
			importForFuture : false
		};

		EventManagerService
				.registerEventListener(
						EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.IMPORT_BY_OVERRIDING,
						importByOverridingExistingRecords);

		function adaptOtherHubHourData() {
			vm.importHour.carrier = selectCarrierFromList(
					vm.importHour.carrierCode,
					modalParams.masterList.autoImportClients);
			return angular.copy(vm.importHour);
		}
		;

		function selectCarrierFromList(carrierCode, list) {
			if (!!carrierCode && !!list) {
				return _.find(list, {
					hubCode : carrierCode
				});
			}
			return null;
		}
		;

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.importHoursData.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.importHoursData.fromDate,
									"DD/MM/YYYY"));
		}
		;

		function isFutureDate(date) {
			return moment().isBefore(moment(date, "DD/MM/YYYY"));
		}
		;

		function isImportRecordWithinMultipleMonth() {
			if (!isDateFormatInvalid(vm.model.importHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.importHoursData.toDate)
					&& !vm.model.fromDateAfterToDate
					&& !vm.model.importForFuture
					&& moment(vm.model.importHoursData.fromDate, "DD/MM/YYYY")
							.format("MM/YYYY") !== moment(
							vm.model.importHoursData.toDate, "DD/MM/YYYY")
							.format("MM/YYYY")) {
				return true;
			}
			return false;
		}
		;

		function isImportForFuture() {
			if (!isDateFormatInvalid(vm.model.importHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.importHoursData.toDate)
					&& !vm.model.fromDateAfterToDate
					&& (isFutureDate(vm.model.importHoursData.fromDate) || isFutureDate(vm.model.importHoursData.toDate))) {
				return true;
			}
			return false;
		}

		vm.changeField = function(flag) {
			if (flag == 'fromDate') {
				var tempFromDate = moment(vm.model.importHoursData.fromDate,
						"DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
				vm.model.importHoursData.toDate = tempFromDate;
			}
			if (!isDateFormatInvalid(vm.model.importHoursData.fromDate)
					&& !isDateFormatInvalid(vm.model.importHoursData.toDate)) {
				vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
				vm.model.importForFuture = isImportForFuture();
			} else {
				vm.model.fromDateAfterToDate = false;
				vm.model.importForFuture = false;
			}
		};

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		;

		function getImportOtherHubRequest(hoursDTO, isOverrideRequired) {
			var req = {};
			req.fromDate = hoursDTO.fromDate;
			req.toDate = hoursDTO.toDate;
			req.tenantCode = hoursDTO.carrier.hubCode;
			req.otherHubCrewId = hoursDTO.otherHubCrewId;
			req.crewProfileId = hoursDTO.crewProfileId;
			req.overrideRequired = !!hoursDTO.overrideRequired ? hoursDTO.overrideRequired
					: false;
			return req;
		}

		function importByOverridingExistingRecords(isOverrideRequired) {
			vm.model.importHoursData.overrideRequired = isOverrideRequired;
			vm.importOtherHubHours(vm.model.importHoursData);
		}

		vm.importOtherHubHours = function(hoursDTO) {
			if (!!vm.otherHubForm && !!vm.otherHubForm.$submitted) {
				vm.otherHubForm.$submitted = true;
			}
			vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
			vm.model.importForFuture = isImportForFuture();
			if (isValidImportHoursData()) {
				var param = getImportOtherHubRequest(hoursDTO);

				ProfileService
						.importHoursData(
								param,
								function(response) {
									if (response.success) {
										MessageService
												.success(MessageService.MESSAGES.CREW_PROFILE.IMPORT_SUCCESS);
										vm.onCloseClick();
										EventManagerService
												.notifyEventListeners(
														EventManagerService.EVENT.TOOLBAR.OTHER_HUB_HOURS.SEARCH,
														'A');
									} else {
										PopupManager.openModal(
												'OTHER_HUB_OVERLAPPING_POPUP',
												response,
												confirmOverlappingDutyRanges);
										$uibModalInstance
												.close(modalParams.close);

									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		};

		function confirmOverlappingDutyRanges() {
		}
		;

		function isValidImportHoursData() {
			if (!!vm.otherHubForm && vm.otherHubForm.$valid) {
				return true;
			} else if (vm.model.importHoursData.carrier.hubCode !== ''
					&& !vm.model.fromDateAfterToDate
					&& !vm.model.importForFuture) {
				return true;
			}
			return false;
		}

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

	}
}());
